import { useTranslation } from "react-i18next";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function TeilsicherheitsbeiwertBodenkenngroessen({ teilsicherheitsbeiwertBodenkenngroessen = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterSoil.partialSafeFactor")}</p>}
      indicesValue={
        <span>
          &gamma;<sub>cu</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText
            value={teilsicherheitsbeiwertBodenkenngroessen}
            decimalScale={1}
            fixedDecimalScale={true}
          />
        </span>
      }
      formulaValue={
        <ToolTip
          id={"TeilsicherheitsbeiwertBodenkenngroessen"}
          type={IconType.INFO}
          text={t("inner.buckling.ofner.parameterSoil.partialSafeFactor_subText")}
        />
      }
    />
  );
}

export default TeilsicherheitsbeiwertBodenkenngroessen;
